import React, {useEffect, useState} from 'react'
import {useHistory} from 'react-router-dom'
import Navbar from "../components/navbar"
import Menu from "../components/menu"
import TitleH1 from "../components/titleH1"
import DivWhite from "../components/divWhite"
import TitleH3 from "../components/titleH3"
//---REDUX
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import allTheActions from '../actions'
import Image from "../components/image";
import HorizontalAlign from "../components/horizontalAlign";
import Button from "../components/button";
//---

const Clubs = props => {
    const [clubs, setClubs] = useState([])

    const history = useHistory()

    useEffect(() => {
        const fetchClubs = async () => {
            const res = await props.actions.club.getAllClubs()
            if (res) setClubs(await res.clubs)
            else history.push('/profile')
        }
        fetchClubs()
    }, [props.actions.club, history])

    return <div>
        <Navbar/>
        <Menu/>
        <HorizontalAlign content={
            <>
                <TitleH1 content="CLUBS"/>
                {
                    localStorage.getItem('admin') ?
                        <Button value="Ajouter un nouveau club"
                                marginTop="0" width="auto" onClick={() => history.push('/create-club')}/>
                    : null
                }

            </>
        } alignItems="center" justifyContent="space-between"/>
        {
            (clubs.length > 0) ?
                clubs.map(club => {
                    return (
                        <DivWhite
                            key={club._id}
                            content={
                                <>
                                    <Image src={`https://khaktus.fr/3fts/${club._id}/${club.photo}`}
                                           width="auto"
                                           height="80px"/>
                                    <TitleH3 content={club.nom} marginTop="10px" marginBottom="0" textAlign="center"
                                             cursor="pointer"/>
                                </>
                            }
                            textAlign="center"
                            padding="20px"
                            width="45%"
                            margin="15px"
                            onClick={() => history.push(`/club/${club._id}`)}
                        />
                    )
                })
                : null
        }


    </div>
}

const mapStateToProps = state => ({
    clubState: state.club,
    licenceState: state.licence
})

const mapDispatchToProps = () => dispatch => ({
    actions: {
        club: bindActionCreators(allTheActions.club, dispatch),
        licence: bindActionCreators(allTheActions.licence, dispatch)
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Clubs)
